import * as Rules from "./Rules";
import { SDQuery_Types } from "../../contracts";
export const queryValidators = {
    default: Rules.isValidQuery,
    [SDQuery_Types.GetSports]: Rules.sportsParams
};
//# sourceMappingURL=index.js.map